var $ = jQuery;
$(document).ready(function() {
	if(module_read_cookie("cookies_allowed") == ''){
		$(".codepix-cookiebar").show();
	}
	else if(module_read_cookie("cookies_allowed") == 'false') {
		$('.codepix-cookiebar-prefs').fadeIn(100);
	}

	$('.js-cookie-prefs').on('click', function() {
		module_view_cookie_bar();
	});
});

function module_set_cookie(cookieName, cookieValue, nDays) {
	var today = new Date();
	var expire = new Date();
	if (nDays==null || nDays==0) nDays=1;
	expire.setTime(today.getTime() + 3600000*24*nDays);
	document.cookie = cookieName+"="+escape(cookieValue)+ ";expires="+expire.toGMTString()+"; path=/";
}
function module_read_cookie(cookieName) {
	var theCookie=" "+document.cookie;
	var ind=theCookie.indexOf(" "+cookieName+"=");
	if (ind==-1) ind=theCookie.indexOf(";"+cookieName+"=");
	if (ind==-1 || cookieName=="") return "";
	var ind1=theCookie.indexOf(";",ind+1);
	if (ind1==-1) ind1=theCookie.length;
	return unescape(theCookie.substring(ind+cookieName.length+2,ind1));
}
function module_delete_cookie(cookieName) {
	var today = new Date();
	var expire = new Date() - 30;
	expire.setTime(today.getTime() - 3600000*24*90);
	document.cookie = cookieName+"="+escape(cookieValue)+ ";expires="+expire.toGMTString();
}
function module_accept_cookies() {
	module_set_cookie('cookies_allowed', true, 365);
	$(".codepix-cookiebar").fadeOut(100);
}
function module_reject_cookies() {
	module_set_cookie('cookies_allowed', false, 365);
	$(".codepix-cookiebar").fadeOut(100);
	$('.codepix-cookiebar-prefs').fadeIn(100);
}

function module_view_cookie_bar() {
	$(".codepix-cookiebar").fadeIn(100);
	$('.codepix-cookiebar-prefs').fadeOut(100);
}